// C2 · Shop menu (sections/c2-shop-menu.liquid). Moves the panels into the theme's header without editing it:
// - desktop: into the <details> of the menu item named in the section (e.g. "Shop"); the theme's mega menu of
//   that item is hidden, the theme keeps opening / closing the <details> on hover or click as before;
// - mobile: at the top of the menu drawer, in place of the drawer's menu list.
// Then: tabs (one open at a time, the first one open), and the arrows of each row.
(() => {
  const norm = (t) => (t || '').replace(/\s+/g, ' ').trim().toLowerCase();

  const accordion = (panel) => {
    const tabs = [...panel.querySelectorAll('[data-c2sm-tab]')];
    const open = (tab) => tabs.forEach((t) => {
      const on = t === tab;
      t.querySelector('[data-c2sm-toggle]').setAttribute('aria-expanded', String(on));
      t.querySelector('[data-c2sm-body]').hidden = !on;
      if (on) requestAnimationFrame(() => arrows(t));
    });
    // a click on the open tab (its "-") closes it; on another tab, opens that one
    tabs.forEach((t) => t.querySelector('[data-c2sm-toggle]').addEventListener('click', () => {
      open(t.querySelector('[data-c2sm-toggle]').getAttribute('aria-expanded') === 'true' ? null : t);
    }));
    if (tabs[0]) open(tabs[0]);
    panel.querySelectorAll('[data-c2sm-step]').forEach((b) => b.addEventListener('click', () => {
      const track = b.closest('[data-c2sm-body]').querySelector('[data-c2sm-track]');
      const card = track.firstElementChild;
      track.scrollBy({ left: Number(b.dataset.c2smStep) * (card ? card.getBoundingClientRect().width * 2 : track.clientWidth), behavior: 'smooth' });
    }));
    panel.querySelectorAll('[data-c2sm-track]').forEach((track) => {
      track.addEventListener('scroll', () => requestAnimationFrame(() => arrows(track.closest('[data-c2sm-tab]'))), { passive: true });
    });
  };

  // mobile top tabs: each shows its pane (collections, or the links of a menu) without leaving the page
  const panes = (panel) => {
    const btns = [...panel.querySelectorAll('[data-c2sm-pane-btn]')];
    btns.forEach((b) => b.addEventListener('click', () => {
      btns.forEach((x) => {
        const on = x === b;
        x.classList.toggle('is-current', on);
        x.setAttribute('aria-selected', String(on));
        const pane = panel.querySelector(`[data-c2sm-pane="${x.dataset.c2smPaneBtn}"]`);
        if (pane) pane.hidden = !on;
      });
    }));
  };

  const arrows = (tab) => {
    const body = tab.querySelector('[data-c2sm-body]');
    const track = body.querySelector('[data-c2sm-track]');
    const scrolls = track.scrollWidth > track.clientWidth + 2;
    body.classList.toggle('is-scrollable', scrolls);
    const [prev, next] = body.querySelectorAll('[data-c2sm-step]');
    if (prev) prev.disabled = !scrolls || track.scrollLeft <= 2;
    if (next) next.disabled = !scrolls || track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
  };

  const place = () => {
    const src = document.querySelector('[data-c2sm]');
    if (!src || src.dataset.placed) return;
    src.dataset.placed = '1';
    const trigger = norm(src.dataset.trigger);

    // desktop
    const desktop = src.querySelector('[data-c2sm-desktop]');
    const mobile = src.querySelector('[data-c2sm-mobile]');
    // Speed: the collection tabs arrive in a <template> (inert, nothing to lay out or download) and are written in
    // on the visitor's first touch / mouse move / key, or when the page is idle - before any menu can be opened.
    // The mobile panel's tabs are a copy of the desktop ones (the page carries them once).
    const tpl = src.querySelector('template[data-c2sm-fill]');
    const copy = src.querySelector('[data-c2sm-copy]');
    let filled = !tpl;
    const fill = () => {
      if (filled) return;
      filled = true;
      if (copy) copy.append(tpl.content.cloneNode(true));
      tpl.replaceWith(tpl.content);
      if (desktop && desktopReady) accordion(desktop);
      if (mobile && mobileReady) accordion(mobile);
    };
    let desktopReady = false;
    let mobileReady = false;
    const details = [...document.querySelectorAll('.header__menu details, header details')]
      .find((d) => d.querySelector(':scope > summary') && norm(d.querySelector(':scope > summary').textContent) === trigger);
    if (desktop && details) {
      details.setAttribute('data-c2sm-owner', '');
      details.appendChild(desktop);
      const setTop = () => {
        const header = details.closest('.header-section, header') || details;
        desktop.style.setProperty('--c2sm-top', `${Math.round(header.getBoundingClientRect().bottom)}px`);
        desktop.querySelectorAll('[data-c2sm-tab]').forEach((t) => { if (!t.querySelector('[data-c2sm-body]').hidden) arrows(t); });
      };
      details.addEventListener('toggle', () => { if (details.open) { fill(); setTop(); } });
      window.addEventListener('resize', () => { if (details.open) setTop(); });
      desktopReady = true;
      if (filled) accordion(desktop);
    }

    // mobile drawer
    const list = document.querySelector('.menu-drawer__menus > .menu-drawer__menu, #menu-drawer-dialog .menu-drawer__menu');
    if (mobile && list) {
      list.hidden = true;
      list.style.display = 'none';
      list.parentElement.insertBefore(mobile, list);
      mobileReady = true;
      if (filled) accordion(mobile);
      panes(mobile);
    }

    if (!filled) {
      const events = ['pointerdown', 'pointerover', 'touchstart', 'keydown', 'focusin'];
      const go = () => { events.forEach((e) => document.removeEventListener(e, go, true)); fill(); };
      events.forEach((e) => document.addEventListener(e, go, { capture: true, passive: true }));
      const idle = () => (window.requestIdleCallback ? requestIdleCallback(go, { timeout: 4000 }) : setTimeout(go, 2500));
      if (document.readyState === 'complete') idle(); else window.addEventListener('load', idle, { once: true });
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', place); else place();
  // theme editor: after an edit of this section, drop the panels placed before and place the new ones
  document.addEventListener('shopify:section:load', (e) => {
    if (!e.target.querySelector('[data-c2sm]')) return;
    document.querySelectorAll('.c2sm').forEach((p) => { if (!p.closest('[data-c2sm]')) p.remove(); });
    document.querySelectorAll('[data-c2sm-owner]').forEach((d) => d.removeAttribute('data-c2sm-owner'));
    const list = document.querySelector('.menu-drawer__menus > .menu-drawer__menu, #menu-drawer-dialog .menu-drawer__menu');
    if (list) { list.hidden = false; list.style.display = ''; }
    place();
  });
})();
